export const formatAmount = (amount: unknown): string => {
  const value =
    typeof amount === 'number'
      ? amount
      : typeof amount === 'string'
        ? Number(amount.replace(',', '.'))
        : 0

  if (!Number.isFinite(value)) {
    return '0,00'
  }

  return value.toFixed(2).replace('.', ',')
}
